import React from 'react';

const Timeline = () => {
  const schedule = [
    {
      day: "11th April — Day 1",
      events: [
        { time: "08:00 AM - 10:00 AM", description: "Registrations & Check-in" },
        { time: "10:00 AM - 11:30 AM", description: "Opening Ceremony & Orientation" },
        { time: "12:00 PM", description: "Hackathon Begins", highlight: true },
        { time: "03:00 PM - 05:00 PM", description: "Idea Pitching Round" },
        { time: "05:00 PM - 06:00 PM", description: "Refreshment Break (Snacks on us) & GFG Contest" },
        { time: "Overnight", description: "Hacking Continues", highlight: true }
      ]
    },
    {
      day: "12th April — Day 2",
      events: [
        { time: "08:00 AM", description: "Breakfast (On Us)" },
        { time: "12:00 PM", description: "Coding Round Ends", highlight: true },
        { time: "12:00 PM - 01:00 PM", description: "Break & Preparation Time" },
        { time: "01:00 PM - 04:00 PM", description: "Evaluation & Judging Round" },
        { time: "04:00 PM - 05:30 PM", description: "Closing Ceremony & Results", highlight: true }
      ]
    }
  ];

  return (
    <section id="timeline" className="text-white py-20 px-6">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col gap-6 mb-8">
          <h2 className="text-5xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-[#E61933] to-[#FF33CC] font-['Inter']">Timeline</h2>
          <p className="text-[#a3a3a3] text-xl">
            Follow the schedule to make the most out of your 24 hours.
          </p>
        </div>

        <div className="grid grid-cols-[repeat(auto-fit,minmax(300px,1fr))] gap-8">
          {schedule.map((day, index) => (
            <div key={index} className="bg-white/5 backdrop-blur-md rounded-2xl border border-white/10 p-6 relative overflow-hidden">
               {/* Decorative background elements matching the reference site style */}
               <div className="absolute top-[20%] -left-5 w-[100px] h-[200px] bg-gradient-to-r from-[#E61933] to-transparent opacity-10 rotate-[15deg] blur-[20px] pointer-events-none"></div>

              <div className="mb-6 border-b border-white/10 pb-4">
                <h3 className="text-2xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-[#E61933] to-[#FF33CC] font-['Inter']">{day.day}</h3>
              </div>
              <div className="flex flex-col gap-6">
                {day.events.map((event, idx) => (
                  <div key={idx} className="flex flex-col gap-1">
                    <span className={`text-sm ${event.highlight ? 'text-[#E61933] font-bold' : 'text-[#a3a3a3] font-normal'}`}>{event.time}</span>
                    <span className={`text-lg ${event.highlight ? 'text-white font-semibold' : 'text-[#e5e5e5] font-normal'}`}>{event.description}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Timeline;
